module.exports = __webpack_public_path__ + "img/logo_dark.png?e4404ce222b486a3cbad25ecf207c1ff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo_dark.png
// module id = 1251
// module chunks = 1